import classNames from 'classnames'
import * as React from 'react'
import {Suspense} from 'react'

import {usePermission} from '../../../../../hooks/usePermission'
import {Permission, ROOT_PROJECT_ID} from '../../../../../types'
import IconButton from '../../../../common/IconButton/IconButton'
import {addAgentPoolHint} from '../../../../packages/Hints/HintItems/Hints.agents'
import {useHint} from '../../../../packages/Hints/Hints.hooks'
import {POOLS_SELECTION_ID} from '../AgentsSidebar.types'

import CreateAgentPoolPopup from './CreateAgentPoolPopup/CreateAgentPoolPopup'

import styles from './Title.css'

interface Props {
  title?: string
  id: string
  className?: string
}

function CreateAgentPool() {
  useHint(addAgentPoolHint)
  const [show, setShow] = React.useState(false)
  const handleToggleClick = React.useCallback(() => setShow(true), [setShow])
  const canManageAgentPools = usePermission(Permission.MANAGE_AGENT_POOLS, ROOT_PROJECT_ID)
  const handleClose = React.useCallback(() => {
    setShow(false)
  }, [setShow])
  return canManageAgentPools ? (
    <span data-hint-container-id={addAgentPoolHint.id}>
      <IconButton primary icon="add" onClick={handleToggleClick} title="Create new pool" />
      <CreateAgentPoolPopup hidden={!show} onCreate={handleClose} onClose={handleClose} />
    </span>
  ) : null
}

function Title({title, id, className}: Props) {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <span className={styles.title} data-test-agents-sidebar-title>
        {title}
      </span>
      {id === POOLS_SELECTION_ID ? (
        <Suspense>
          <CreateAgentPool />
        </Suspense>
      ) : null}
    </div>
  )
}
export default React.memo<Props>(Title)
